import { render, staticRenderFns } from "./CmExamBody.vue?vue&type=template&id=59cb2574&lang=pug"
import script from "./CmExamBody.vue?vue&type=script&lang=js"
export * from "./CmExamBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports